//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, ref, computed, watch, nextTick } from "@nuxtjs/composition-api";
import SfDropdown from "~/themes/fiskarsMoominDefault/components/components/molecules/SfDropdown/SfDropdown.vue";
import SfList from "~/themes/fiskarsMoominDefault/components/components/organisms/SfList/SfList.vue";

export default defineComponent({
  name: "MoominDropdown",
  components: {
    SfList,
    SfDropdown,
},
  props: {
    titlePlaceholder: {
      type: [Object, String],
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    dropdownOptions: {
      type: Array,
      default: [],
    },
    hasErrors: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    selectedOption: {
      type: [Object, String],
      default: "",
    },
    cancelButton: {
      type: String,
      default: ""
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    dropdownOptionImageKey: {
      type: String,
      default: ''
    },
    openerAriaLabel: {
      type: String,
      default: "",
    }
  },
  setup(props, {emit}) {
    // Reactive variables using refs
    const dropdownToggle = ref(props.isOpen);
    const _dropdownTitle = computed(() => props.titlePlaceholder);
    const _selectedOption = computed(() => props.selectedOption);
    const dropdownHasErrors = ref(props.hasErrors);
    const activeIndex = ref(-1);
    const optionsListRef = ref(null);

    // Computed property to get the index of the selected option
    const _selectedIndex = computed(() => {
      return props.dropdownOptions.findIndex(
        (option) => option.displayName === _dropdownTitle.value || option === _dropdownTitle.value
      );
    });

    // Method to handle the selection of an option
    const selectValue = (value, index) => {
      dropdownToggle.value = false;
      emit("chosenOption", value, index);
    };

    // Method to scroll the active element into view
    const showActiveElement = (index) => {
      if(index < 0) return;
      const activeButton = optionsListRef.value.$el.querySelectorAll('li')[index];
      activeButton.scrollIntoView({ behavior: 'instant', block: 'nearest' });
    };

    // Method to handle keydown event (arrow navigation and selection)
    const handleKeydown = (event) => {
      if (!dropdownToggle.value) return;

      const { key } = event;
      if (key === 'ArrowDown' || key === 'ArrowUp') {
        event.preventDefault();
        if (key === 'ArrowDown') {
          activeIndex.value = (activeIndex.value + 1) % props.dropdownOptions.length;
        } else if (key === 'ArrowUp') {
          activeIndex.value = (activeIndex.value - 1 + props.dropdownOptions.length) % props.dropdownOptions.length;
        }

        showActiveElement(activeIndex.value);
        // Move focus to the active option
        nextTick(() => {
          const optionButtons = optionsListRef.value?.$el?.querySelectorAll('li button');
          if (optionButtons && optionButtons[activeIndex.value]) {
            optionButtons[activeIndex.value].focus();
          }
        });
      } else if (key === 'Enter') {
        event.preventDefault();
        selectValue(props.dropdownOptions[activeIndex.value], activeIndex.value);
      }
    }

    // Watch for changes in dropdownToggle and set activeIndex accordingly
    watch(dropdownToggle, async (newValue) => {
      if (newValue) {
        await nextTick();
        updateActiveIndex(_selectedIndex.value);
        showActiveElement(activeIndex.value);

        // Move focus to the selected option
        const optionButtons = optionsListRef.value?.$el?.querySelectorAll("li button");
        if (optionButtons?.[_selectedIndex.value]) {
          optionButtons[_selectedIndex.value].focus();
        }
      }
    });

    // Method to handle mouseenter event (update activeIndex)
    const updateActiveIndex = (index) => {
      activeIndex.value = index;
    };

    // Method to check if an option has an image source based on the device type
    const checkOptionHasImageSrc = (optionImage, isDesktop) => {
      if (!optionImage) return '';
      const device = isDesktop ? 'desktop' : 'mobile';
      return optionImage[device];
    }

    return {
      // Exported variables and functions
      checkOptionHasImageSrc,
      dropdownToggle,
      _dropdownTitle,
      _selectedOption,
      dropdownHasErrors,
      _selectedIndex,
      activeIndex,
      handleKeydown,
      selectValue,
      optionsListRef,
      updateActiveIndex,
    }
  }
});
